import Cleave from "cleave.js";

const setPhoneMasking = ($phone, countryCode) => {
  const options =
    countryCode === "US"
      ? {
          numericOnly: true,
          blocks: [0, 3, 0, 3, 4],
          delimiters: ["(", ")", " ", "-"],
        }
      : {
          numericOnly: true,
        };

  return new Cleave($phone, options);
};

export const phoneNumberMasking = ($form) => {
  const $countryCode = $form.find('select[name="CountryCode"]');
  const $phone = $form.find('input[name="Phone"]');

  let cleave = setPhoneMasking($phone, $countryCode.val());

  $countryCode.on("change", (e) => {
    cleave.destroy();
    const $el = $(e.currentTarget);
    cleave = setPhoneMasking($phone, $el.val());
  });
};
